import React from "react";
import {
  Card,
  CardContent,
  Typography,
  CardHeader,
  Grid,
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  FormControl,
  TextField,
  Button,
} from "@mui/material";
import { Info, InsertDriveFileOutlined } from "@mui/icons-material";

import styled from "styled-components";
import { VendorCardTitle } from "../../features/adminOrders/components/adminOrdersViewContent";
import { VendorCardLabel } from "../../features/vendorRegistration/components/StepMain";
import {
  CustomDocumentLink,
  GreenColorDocumentLink,
  RedColorDocumentLink,
} from "./styles/card.style";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { removeBank } from "../../features/bankDetails/redux/bankDetailsSlice";
import { Super } from "../../features/vendorRegistration/components/steps/cardTrial";
import { LoadingButton } from "@mui/lab";
const BankInfoDetails = ({ item, is_domestic, updatedData }) => {
  const {
    id,
    bank_name,
    branch_name,
    city,
    account_name,
    account_number,
    currency,
    ifsc_code,
    address_line_one,
    swift_code,
    vendor_id,
  } = item.item;
  const { loading } = useSelector((state) => state.bankdetails);
  const [openDialog, setOpenDialog] = React.useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();
  const onSubmit = (data) => {
    const payload = {
      bank_id: id,
      vid: vendor_id,
      reason: data.reason,
    };
    dispatch(removeBank(payload));
    setOpenDialog(false);
  };
  // eslint-disable-next-line no-unused-vars
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClose = () => {
    setAnchorEl(null);
  };
  if (item.image) {
    var {
      rtgs_authorization_letter_image_name,
      rtgs_authorization_letter_image,
      cancelled_cheque_image_name,
      cancelled_cheque_image,
      bank_statement_image_name,
      bank_statement_image,
      bank_passbook_copy_with_bank_stamp_image_name,
      bank_passbook_copy_with_bank_stamp_image,
      supporting_document_image_name,
      supporting_document_image,
    } = item.image;
  }
  // const handleMoreVertClick = () => {
  //   // Perform your desired action here
  //   alert("Performing action after clicking MoreVertIcon");
  // };
  // const findUpdatedBankDetails = (key) => {
  //   const newData = updatedData?.find((item, index) => item?.field === key);
  //   if (newData) {
  //     return newData;
  //   } else {
  //     return null;
  //   }
  // };

  const findUpdatedBankDetails = (key) => {
    return (
      updatedData?.find((item) => item?.field === key) ?? {
        old_value: null,
        new_value: null,
      }
    );
  };

  const updated = React.useMemo(
    () => ({
      rtgsName: findUpdatedBankDetails("rtgs_authorization_letter_image_name"),
      rtgsFile: findUpdatedBankDetails("rtgs_authorization_letter_image"),

      chequeFile: findUpdatedBankDetails("cancelled_cheque_image"),
      chequeName: findUpdatedBankDetails("cancelled_cheque_image_name"),

      statementFile: findUpdatedBankDetails("bank_statement_image"),
      statementName: findUpdatedBankDetails("bank_statement_image_name"),

      passbookFile: findUpdatedBankDetails(
        "bank_passbook_copy_with_bank_stamp_image"
      ),
      passbookName: findUpdatedBankDetails(
        "bank_passbook_copy_with_bank_stamp_image_name"
      ),

      supportFile: findUpdatedBankDetails("supporting_document_image"),
      supportName: findUpdatedBankDetails("supporting_document_image_name"),

      cityUpdated: findUpdatedBankDetails("city"),

      branchNameUpdated: findUpdatedBankDetails("branch_name"),

      bankNameUpdated: findUpdatedBankDetails("bank_name"),

      accountNameUpdated: findUpdatedBankDetails("account_name"),

      accountNumberUpdated: findUpdatedBankDetails("account_number"),

      ifscUpdated: findUpdatedBankDetails("ifsc_code"),
      swiftCodeUpdated: findUpdatedBankDetails("swift_code"),

      currencyUpdated: findUpdatedBankDetails("currency"),

      addressUpdated: findUpdatedBankDetails("address_line_one"),
    }),
    [updatedData]
  );

  const NoDocument = ({ color }) => (
    <Typography className="label" sx={{ color }}>
      <Info sx={{ height: 15, width: 15, mr: 0.5 }} />
      There is no document
    </Typography>
  );

  return (
    <>
      <Card>
        <CardHeader />
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={6} md={4}>
              <Typography color="text.secondary" gutterBottom>
                Bank Name:
              </Typography>
              {updated.bankNameUpdated.old_value ||
              updated.bankNameUpdated.new_value ? (
                <>
                  <Typography sx={{ color: "#d32f2f" }}>
                    {" "}
                    {updated.bankNameUpdated.old_value || "Not Applicable"}
                  </Typography>
                  <Typography sx={{ color: "#2e7d32" }}>
                    {" "}
                    {updated.bankNameUpdated.new_value || "Not Applicable"}
                  </Typography>
                </>
              ) : (
                <Typography>{bank_name}</Typography>
              )}
            </Grid>
            <Grid item xs={6} md={4}>
              <Typography color="text.secondary" gutterBottom>
                Branch Name:
              </Typography>
              {updated.branchNameUpdated.old_value ||
              updated.branchNameUpdated.new_value ? (
                <>
                  <Typography sx={{ color: "#d32f2f" }}>
                    {" "}
                    {updated.branchNameUpdated.old_value || "Not Applicable"}
                  </Typography>
                  <Typography sx={{ color: "#2e7d32" }}>
                    {" "}
                    {updated.branchNameUpdated.new_value || "Not Applicable"}
                  </Typography>
                </>
              ) : (
                <Typography>{branch_name}</Typography>
              )}
            </Grid>
            <Grid item xs={6} md={4}>
              <Typography color="text.secondary" gutterBottom>
                Bank Account Holder Name:
              </Typography>
              {updated.accountNameUpdated.old_value ||
              updated.accountNameUpdated.new_value ? (
                <>
                  <Typography sx={{ color: "#d32f2f" }}>
                    {" "}
                    {updated.accountNameUpdated?.old_value || "Not Applicable"}
                  </Typography>
                  <Typography sx={{ color: "#2e7d32" }}>
                    {" "}
                    {updated.accountNameUpdated?.new_value || "Not Applicable"}
                  </Typography>
                </>
              ) : (
                <Typography> {account_name}</Typography>
              )}
            </Grid>
            <Grid item xs={6} md={4}>
              <Typography color="text.secondary" gutterBottom>
                {is_domestic ? "A/C Number:" : "IBA Number:"}
              </Typography>
              {updated.accountNumberUpdated.old_value ||
              updated.accountNumberUpdated.new_value ? (
                <>
                  <Typography sx={{ color: "#d32f2f" }}>
                    {updated.accountNumberUpdated?.old_value ||
                      "Not Applicable"}
                  </Typography>
                  <Typography sx={{ color: "#2e7d32" }}>
                    {" "}
                    {updated.accountNumberUpdated?.new_value ||
                      "Not Applicable"}
                  </Typography>
                </>
              ) : (
                <Typography> {account_number}</Typography>
              )}
            </Grid>
            <Grid item xs={6} md={4}>
              <Typography color="text.secondary" gutterBottom>
                {is_domestic ? "IFSC Code:" : "Swift Code"}
              </Typography>
              <Typography>
                {updated.ifscUpdated.new_value ||
                updated.ifscUpdated.old_value ||
                updated.swiftCodeUpdated.old_value ||
                updated.swiftCodeUpdated.new_value ? (
                  <>
                    <Typography sx={{ color: "#d32f2f" }}>
                      {" "}
                      {is_domestic
                        ? updated.ifscUpdated?.old_value
                          ? updated.ifscUpdated?.old_value
                          : "Not Applicable"
                        : updated.swiftCodeUpdated.new_value.old_value
                        ? updated.swiftCodeUpdated.new_value.old_value
                        : "Not Applicable"}
                    </Typography>
                    <Typography sx={{ color: "#2e7d32" }}>
                      {" "}
                      {is_domestic
                        ? updated.ifscUpdated?.new_value
                          ? updated.ifscUpdated?.new_value
                          : "Not Applicable"
                        : updated.swiftCodeUpdated.new_value?.new_value
                        ? updated.swiftCodeUpdated.new_value?.new_value
                        : "Not Applicable"}{" "}
                    </Typography>
                  </>
                ) : (
                  <Typography>
                    {is_domestic
                      ? ifsc_code
                        ? ifsc_code
                        : "Not Applicable"
                      : swift_code
                      ? swift_code
                      : "Not Applicable"}
                  </Typography>
                )}
              </Typography>
            </Grid>
            <Grid item xs={6} md={4}>
              <Typography color="text.secondary" gutterBottom>
                City
              </Typography>
              {updated.cityUpdated.old_value ||
              updated.cityUpdated.new_value ? (
                <>
                  <Typography sx={{ color: "#d32f2f" }}>
                    {" "}
                    {updated.cityUpdated.old_value || "Not Applicable"}
                  </Typography>
                  <Typography sx={{ color: "#2e7d32" }}>
                    {" "}
                    {updated.cityUpdated.new_value || "Not Applicable"}
                  </Typography>
                </>
              ) : (
                <Typography>{city}</Typography>
              )}
            </Grid>
            <Grid item xs={6} md={4}>
              <Typography color="text.secondary" gutterBottom>
                Currency:
              </Typography>
              {updated.currencyUpdated.old_value ||
              updated.currencyUpdated.new_value ? (
                <>
                  <Typography sx={{ color: "#d32f2f" }}>
                    {" "}
                    {updated.currencyUpdated?.old_value || "Not Applicable"}
                  </Typography>
                  <Typography sx={{ color: "#2e7d32" }}>
                    {" "}
                    {updated.currencyUpdated?.new_value || "Not Applicable"}
                  </Typography>
                </>
              ) : (
                <Typography> {currency}</Typography>
              )}
            </Grid>
            {is_domestic && (
              <Grid item xs={6} md={4}>
                <Typography color="text.secondary" gutterBottom>
                  Address:
                </Typography>
                {updated.addressUpdated.old_value ||
                updated.addressUpdated.new_value ? (
                  <>
                    <Typography sx={{ color: "#d32f2f" }}>
                      {updated.addressUpdated?.old_value || "Not Applicable"}
                    </Typography>
                    <Typography sx={{ color: "#2e7d32" }}>
                      {" "}
                      {updated.addressUpdated?.new_value || "Not Applicable"}
                    </Typography>
                  </>
                ) : (
                  <Typography>
                    {address_line_one ? address_line_one : "Not Applicable"}
                  </Typography>
                )}
              </Grid>
            )}
          </Grid>
          <br />
          <VendorCardTitle>Documets:</VendorCardTitle>
          <Grid
            container
            spacing={3}
            sx={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            {/* <Grid item xs={6} md={4}>
              <Typography className="label">RTGS DOCUMENT</Typography>
              {findUpdatedBankDetails("rtgs_authorization_letter_image_name") ||
              findUpdatedBankDetails("rtgs_authorization_letter_image") ? (
                <>
                  <VendorCardLabel>
                    {findUpdatedBankDetails(
                      "rtgs_authorization_letter_image_name"
                    )?.old_value ? (
                      findUpdatedBankDetails("rtgs_authorization_letter_image")
                        ?.old_value ? (
                        <RedColorDocumentLink
                          href={
                            findUpdatedBankDetails(
                              "rtgs_authorization_letter_image"
                            )?.old_value
                          }
                          target="_blank"
                        >
                          <InsertDriveFileOutlined
                            style={{
                              marginTop: "-1px",
                              marginRight: "3px",
                              height: "12px",
                              width: "12px",
                            }}
                          />
                          RTGS document
                        </RedColorDocumentLink>
                      ) : (
                        <Typography className="label" sx={{ color: "#d32f2f" }}>
                          <Info
                            sx={{
                              marginTop: "-1px",
                              marginRight: "1px",
                              fill: "grey",
                              height: "15px",
                              width: "15px",
                            }}
                          />{" "}
                          There is no RTGS document
                        </Typography>
                      )
                    ) : (
                      <Typography className="label" sx={{ color: "#d32f2f" }}>
                        <Info
                          sx={{
                            marginTop: "-1px",
                            marginRight: "1px",
                            fill: "grey",
                            height: "15px",
                            width: "15px",
                          }}
                        />{" "}
                        There is no RTGS document
                      </Typography>
                    )}
                  </VendorCardLabel>
                  <VendorCardLabel>
                    {findUpdatedBankDetails(
                      "rtgs_authorization_letter_image_name"
                    ).new_value ? (
                      findUpdatedBankDetails("rtgs_authorization_letter_image")
                        .new_value ? (
                        <GreenColorDocumentLink
                          href={
                            findUpdatedBankDetails(
                              "rtgs_authorization_letter_image"
                            ).new_value
                          }
                          target="_blank"
                        >
                          <InsertDriveFileOutlined
                            style={{
                              marginTop: "-1px",
                              marginRight: "3px",
                              height: "12px",
                              width: "12px",
                            }}
                          />
                          RTGS document
                        </GreenColorDocumentLink>
                      ) : (
                        <Typography className="label" sx={{ color: "#2e7d32" }}>
                          <Info
                            sx={{
                              marginTop: "-1px",
                              marginRight: "1px",
                              fill: "grey",
                              height: "15px",
                              width: "15px",
                            }}
                          />{" "}
                          There is no RTGS document
                        </Typography>
                      )
                    ) : (
                      <Typography className="label" sx={{ color: "#2e7d32" }}>
                        <Info
                          sx={{
                            marginTop: "-1px",
                            marginRight: "1px",
                            fill: "grey",
                            height: "15px",
                            width: "15px",
                          }}
                        />{" "}
                        There is no RTGS document
                      </Typography>
                    )}
                  </VendorCardLabel>
                </>
              ) : (
                <VendorCardLabel>
                  {rtgs_authorization_letter_image_name ? (
                    rtgs_authorization_letter_image_name ? (
                      <CustomDocumentLink
                        href={rtgs_authorization_letter_image}
                        target="_blank"
                      >
                        <InsertDriveFileOutlined
                          style={{
                            marginTop: "-1px",
                            marginRight: "3px",
                            height: "12px",
                            width: "12px",
                          }}
                        />
                        RTGS document
                      </CustomDocumentLink>
                    ) : (
                      <Typography className="label">
                        <Info
                          sx={{
                            marginTop: "-1px",
                            marginRight: "1px",
                            fill: "grey",
                            height: "15px",
                            width: "15px",
                          }}
                        />{" "}
                        There is no RTGS document
                      </Typography>
                    )
                  ) : (
                    <Typography className="label">
                      <Info
                        sx={{
                          marginTop: "-1px",
                          marginRight: "1px",
                          fill: "grey",
                          height: "15px",
                          width: "15px",
                        }}
                      />{" "}
                      There is no RTGS document
                    </Typography>
                  )}
                </VendorCardLabel>
              )}
            </Grid> */}
            {/* new RTGS document */}
            <Grid item xs={6} md={4}>
              <Typography className="label">RTGS DOCUMENT</Typography>

              {updated.rtgsName.new_value || updated.rtgsFile.new_value ? (
                <>
                  <VendorCardLabel>
                    {updated.rtgsFile.old_value ? (
                      <RedColorDocumentLink
                        href={updated.rtgsFile.old_value}
                        target="_blank"
                      >
                        <InsertDriveFileOutlined
                          sx={{ height: 12, width: 12, mr: 0.5 }}
                        />
                        RTGS document
                      </RedColorDocumentLink>
                    ) : (
                      <NoDocument color="#d32f2f" />
                    )}
                  </VendorCardLabel>

                  <VendorCardLabel>
                    {updated.rtgsFile.new_value ? (
                      <GreenColorDocumentLink
                        href={updated.rtgsFile.new_value}
                        target="_blank"
                      >
                        <InsertDriveFileOutlined
                          sx={{ height: 12, width: 12, mr: 0.5 }}
                        />
                        RTGS document
                      </GreenColorDocumentLink>
                    ) : (
                      <NoDocument color="#2e7d32" />
                    )}
                  </VendorCardLabel>
                </>
              ) : (
                <VendorCardLabel>
                  {rtgs_authorization_letter_image ? (
                    <CustomDocumentLink
                      href={rtgs_authorization_letter_image}
                      target="_blank"
                    >
                      <InsertDriveFileOutlined
                        sx={{ height: 12, width: 12, mr: 0.5 }}
                      />
                      RTGS document
                    </CustomDocumentLink>
                  ) : (
                    <NoDocument />
                  )}
                </VendorCardLabel>
              )}
            </Grid>
            {/* <Grid item xs={6} md={4}>
              <Typography className="label">
                CANCELLED CHEQUE DOCUMENT
              </Typography>
              {findUpdatedBankDetails("cancelled_cheque_image_name") ||
              findUpdatedBankDetails("cancelled_cheque_image") ? (
                <>
                  <VendorCardLabel>
                    {findUpdatedBankDetails("cancelled_cheque_image")
                      ?.old_value ? (
                      findUpdatedBankDetails("cancelled_cheque_image")
                        ?.old_value ? (
                        <RedColorDocumentLink
                          href={
                            findUpdatedBankDetails("cancelled_cheque_image")
                              .old_value
                          }
                          target="_blank"
                        >
                          <InsertDriveFileOutlined
                            style={{
                              marginTop: "-1px",
                              marginRight: "3px",
                              height: "12px",
                              width: "12px",
                            }}
                          />
                          Cancelled cheque document
                        </RedColorDocumentLink>
                      ) : (
                        <Typography className="label" sx={{ color: "#d32f2f" }}>
                          <Info
                            sx={{
                              marginTop: "-1px",
                              marginRight: "1px",
                              fill: "grey",
                              height: "15px",
                              width: "15px",
                            }}
                          />{" "}
                          There is no cancelled cheque document
                        </Typography>
                      )
                    ) : (
                      <Typography className="label" sx={{ color: "#d32f2f" }}>
                        <Info
                          sx={{
                            marginTop: "-1px",
                            marginRight: "1px",
                            fill: "grey",
                            height: "15px",
                            width: "15px",
                          }}
                        />{" "}
                        There is no cancelled cheque document
                      </Typography>
                    )}
                  </VendorCardLabel>
                  <VendorCardLabel>
                    {findUpdatedBankDetails("cancelled_cheque_image")
                      .new_value ? (
                      findUpdatedBankDetails("cancelled_cheque_image")
                        .new_value ? (
                        <GreenColorDocumentLink
                          href={
                            findUpdatedBankDetails("cancelled_cheque_image")
                              .new_value
                          }
                          target="_blank"
                        >
                          <InsertDriveFileOutlined
                            style={{
                              marginTop: "-1px",
                              marginRight: "3px",
                              height: "12px",
                              width: "12px",
                            }}
                          />
                          Cancelled cheque document
                        </GreenColorDocumentLink>
                      ) : (
                        <Typography className="label" sx={{ color: "#2e7d32" }}>
                          <Info
                            sx={{
                              marginTop: "-1px",
                              marginRight: "1px",
                              fill: "grey",
                              height: "15px",
                              width: "15px",
                            }}
                          />{" "}
                          There is no cancelled cheque document
                        </Typography>
                      )
                    ) : (
                      <Typography className="label" sx={{ color: "#2e7d32" }}>
                        <Info
                          sx={{
                            marginTop: "-1px",
                            marginRight: "1px",
                            fill: "grey",
                            height: "15px",
                            width: "15px",
                          }}
                        />{" "}
                        There is no cancelled cheque document
                      </Typography>
                    )}
                  </VendorCardLabel>
                </>
              ) : (
                <VendorCardLabel>
                  {cancelled_cheque_image_name ? (
                    cancelled_cheque_image_name ? (
                      <CustomDocumentLink
                        href={cancelled_cheque_image}
                        target="_blank"
                      >
                        <InsertDriveFileOutlined
                          style={{
                            marginTop: "-1px",
                            marginRight: "3px",
                            height: "12px",
                            width: "12px",
                          }}
                        />
                        Cancelled cheque document
                      </CustomDocumentLink>
                    ) : (
                      <Typography className="label">
                        <Info
                          sx={{
                            marginTop: "-1px",
                            marginRight: "1px",
                            fill: "grey",
                            height: "15px",
                            width: "15px",
                          }}
                        />{" "}
                        There is no cancelled cheque document
                      </Typography>
                    )
                  ) : (
                    <Typography className="label">
                      <Info
                        sx={{
                          marginTop: "-1px",
                          marginRight: "1px",
                          fill: "grey",
                          height: "15px",
                          width: "15px",
                        }}
                      />{" "}
                      There is no cancelled cheque document
                    </Typography>
                  )}
                </VendorCardLabel>
              )}
            </Grid> */}
            {/* new cancelled cheque document */}
            <Grid item xs={6} md={4}>
              <Typography className="label">
                CANCELLED CHEQUE DOCUMENT
              </Typography>

              {updated.chequeName.new_value || updated.chequeFile.new_value ? (
                <>
                  <VendorCardLabel>
                    {updated.chequeFile.old_value ? (
                      <RedColorDocumentLink
                        href={updated.chequeFile.old_value}
                        target="_blank"
                      >
                        <InsertDriveFileOutlined
                          sx={{ height: 12, width: 12, mr: 0.5 }}
                        />
                        Cancelled cheque document
                      </RedColorDocumentLink>
                    ) : (
                      <NoDocument color="#d32f2f" />
                    )}
                  </VendorCardLabel>

                  <VendorCardLabel>
                    {updated.chequeFile.new_value ? (
                      <GreenColorDocumentLink
                        href={updated.chequeFile.new_value}
                        target="_blank"
                      >
                        <InsertDriveFileOutlined
                          sx={{ height: 12, width: 12, mr: 0.5 }}
                        />
                        Cancelled cheque document
                      </GreenColorDocumentLink>
                    ) : (
                      <NoDocument color="#2e7d32" />
                    )}
                  </VendorCardLabel>
                </>
              ) : (
                <VendorCardLabel>
                  {cancelled_cheque_image ? (
                    <CustomDocumentLink
                      href={cancelled_cheque_image}
                      target="_blank"
                    >
                      <InsertDriveFileOutlined
                        sx={{ height: 12, width: 12, mr: 0.5 }}
                      />
                      Cancelled cheque document
                    </CustomDocumentLink>
                  ) : (
                    <NoDocument />
                  )}
                </VendorCardLabel>
              )}
            </Grid>
            {/* old bank statement document */}
            {/* <Grid item xs={6} md={4}>
              <Typography className="label">BANK STATEMENT DOCUMENT</Typography>
              {findUpdatedBankDetails("bank_statement_image_name") ||
              findUpdatedBankDetails("bank_statement_image") ? (
                <>
                  <VendorCardLabel>
                    {findUpdatedBankDetails("bank_statement_image_name")
                      .old_value ? (
                      findUpdatedBankDetails("bank_statement_image_name")
                        .old_value ? (
                        <RedColorDocumentLink
                          href={
                            findUpdatedBankDetails("bank_statement_image")
                              .old_value
                          }
                          target="_blank"
                        >
                          <InsertDriveFileOutlined
                            style={{
                              marginTop: "-1px",
                              marginRight: "3px",
                              height: "12px",
                              width: "12px",
                            }}
                          />
                          Bank statement document
                        </RedColorDocumentLink>
                      ) : (
                        <Typography className="label" sx={{ color: "#d32f2f" }}>
                          <Info
                            sx={{
                              marginTop: "-1px",
                              marginRight: "1px",
                              fill: "grey",
                              height: "15px",
                              width: "15px",
                            }}
                          />{" "}
                          There is no Bank statement document document
                        </Typography>
                      )
                    ) : (
                      <Typography className="label" sx={{ color: "#d32f2f" }}>
                        <Info
                          sx={{
                            marginTop: "-1px",
                            marginRight: "1px",
                            fill: "grey",
                            height: "15px",
                            width: "15px",
                          }}
                        />
                        There is no Bank statement document document
                      </Typography>
                    )}
                  </VendorCardLabel>
                  <VendorCardLabel>
                    {findUpdatedBankDetails("bank_statement_image_name")
                      .new_value ? (
                      findUpdatedBankDetails("bank_statement_image_name")
                        .new_value ? (
                        <GreenColorDocumentLink
                          href={
                            findUpdatedBankDetails("bank_statement_image")
                              .new_value
                          }
                          target="_blank"
                        >
                          <InsertDriveFileOutlined
                            style={{
                              marginTop: "-1px",
                              marginRight: "3px",
                              height: "12px",
                              width: "12px",
                            }}
                          />
                          Bank statement document
                        </GreenColorDocumentLink>
                      ) : (
                        <Typography className="label" sx={{ color: "#2e7d32" }}>
                          <Info
                            sx={{
                              marginTop: "-1px",
                              marginRight: "1px",
                              fill: "grey",
                              height: "15px",
                              width: "15px",
                            }}
                          />{" "}
                          There is no Bank statement document document
                        </Typography>
                      )
                    ) : (
                      <Typography className="label" sx={{ color: "#2e7d32" }}>
                        <Info
                          sx={{
                            marginTop: "-1px",
                            marginRight: "1px",
                            fill: "grey",
                            height: "15px",
                            width: "15px",
                          }}
                        />
                        There is no Bank statement document document
                      </Typography>
                    )}
                  </VendorCardLabel>
                </>
              ) : (
                <VendorCardLabel>
                  {bank_statement_image_name ? (
                    bank_statement_image_name ? (
                      <CustomDocumentLink
                        href={bank_statement_image}
                        target="_blank"
                      >
                        <InsertDriveFileOutlined
                          style={{
                            marginTop: "-1px",
                            marginRight: "3px",
                            height: "12px",
                            width: "12px",
                          }}
                        />
                        Bank statement document
                      </CustomDocumentLink>
                    ) : (
                      <Typography className="label">
                        <Info
                          sx={{
                            marginTop: "-1px",
                            marginRight: "1px",
                            fill: "grey",
                            height: "15px",
                            width: "15px",
                          }}
                        />{" "}
                        There is no Bank statement document document
                      </Typography>
                    )
                  ) : (
                    <Typography className="label">
                      <Info
                        sx={{
                          marginTop: "-1px",
                          marginRight: "1px",
                          fill: "grey",
                          height: "15px",
                          width: "15px",
                        }}
                      />
                      There is no Bank statement document document
                    </Typography>
                  )}
                </VendorCardLabel>
              )}
            </Grid> */}
            {/* new bank statement document */}
            <Grid item xs={6} md={4}>
              <Typography className="label">BANK STATEMENT DOCUMENT</Typography>

              {updated.statementName.new_value ||
              updated.statementFile.new_value ? (
                <>
                  <VendorCardLabel>
                    {updated.statementFile.old_value ? (
                      <RedColorDocumentLink
                        href={updated.statementFile.old_value}
                        target="_blank"
                      >
                        <InsertDriveFileOutlined
                          sx={{ height: 12, width: 12, mr: 0.5 }}
                        />
                        Bank statement document{" "}
                      </RedColorDocumentLink>
                    ) : (
                      <NoDocument color="#d32f2f" />
                    )}
                  </VendorCardLabel>

                  <VendorCardLabel>
                    {updated.statementFile.new_value ? (
                      <GreenColorDocumentLink
                        href={updated.statementFile.new_value}
                        target="_blank"
                      >
                        <InsertDriveFileOutlined
                          sx={{ height: 12, width: 12, mr: 0.5 }}
                        />
                        Bank statement document
                      </GreenColorDocumentLink>
                    ) : (
                      <NoDocument color="#2e7d32" />
                    )}
                  </VendorCardLabel>
                </>
              ) : (
                <VendorCardLabel>
                  {bank_statement_image ? (
                    <CustomDocumentLink
                      href={bank_statement_image}
                      target="_blank"
                    >
                      <InsertDriveFileOutlined
                        sx={{ height: 12, width: 12, mr: 0.5 }}
                      />
                      Bank statement document
                    </CustomDocumentLink>
                  ) : (
                    <NoDocument />
                  )}
                </VendorCardLabel>
              )}
            </Grid>
          </Grid>
          <br />
          <Grid
            container
            spacing={3}
            sx={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            {/* old passbook document */}
            {/* <Grid item xs={6} md={4}>
              <Typography className="label">BANK PASSBOOK DOCUMENT</Typography>
              {findUpdatedBankDetails(
                "bank_passbook_copy_with_bank_stamp_image"
              ) ||
              findUpdatedBankDetails(
                "bank_passbook_copy_with_bank_stamp_image_name"
              ) ? (
                <>
                  <VendorCardLabel>
                    {findUpdatedBankDetails(
                      "bank_passbook_copy_with_bank_stamp_image_name"
                    ).old_value ? (
                      findUpdatedBankDetails(
                        "bank_passbook_copy_with_bank_stamp_image_name"
                      ).old_value ? (
                        <RedColorDocumentLink
                          href={
                            findUpdatedBankDetails(
                              "bank_passbook_copy_with_bank_stamp_image"
                            ).old_value
                          }
                          target="_blank"
                        >
                          <InsertDriveFileOutlined
                            style={{
                              marginTop: "-1px",
                              marginRight: "3px",
                              height: "12px",
                              width: "12px",
                            }}
                          />
                          Bank Passbook document
                        </RedColorDocumentLink>
                      ) : (
                        <Typography className="label" sx={{ color: "#d32f2f" }}>
                          <Info
                            sx={{
                              marginTop: "-1px",
                              marginRight: "1px",
                              fill: "grey",
                              height: "15px",
                              width: "15px",
                            }}
                          />{" "}
                          There is no bank passbook document
                        </Typography>
                      )
                    ) : (
                      <Typography className="label" sx={{ color: "#d32f2f" }}>
                        <Info
                          sx={{
                            marginTop: "-1px",
                            marginRight: "1px",
                            fill: "grey",
                            height: "15px",
                            width: "15px",
                          }}
                        />{" "}
                        There is no bank passbook document
                      </Typography>
                    )}
                  </VendorCardLabel>
                  <VendorCardLabel>
                    {findUpdatedBankDetails(
                      "bank_passbook_copy_with_bank_stamp_image_name"
                    ).new_value ? (
                      findUpdatedBankDetails(
                        "bank_passbook_copy_with_bank_stamp_image_name"
                      ).new_value ? (
                        <GreenColorDocumentLink
                          href={
                            findUpdatedBankDetails(
                              "bank_passbook_copy_with_bank_stamp_image"
                            ).new_value
                          }
                          target="_blank"
                        >
                          <InsertDriveFileOutlined
                            style={{
                              marginTop: "-1px",
                              marginRight: "3px",
                              height: "12px",
                              width: "12px",
                            }}
                          />
                          Bank Passbook document
                        </GreenColorDocumentLink>
                      ) : (
                        <Typography className="label" sx={{ color: "#2e7d32" }}>
                          <Info
                            sx={{
                              marginTop: "-1px",
                              marginRight: "1px",
                              fill: "grey",
                              height: "15px",
                              width: "15px",
                            }}
                          />{" "}
                          There is no bank passbook document
                        </Typography>
                      )
                    ) : (
                      <Typography className="label" sx={{ color: "#2e7d32" }}>
                        <Info
                          sx={{
                            marginTop: "-1px",
                            marginRight: "1px",
                            fill: "grey",
                            height: "15px",
                            width: "15px",
                          }}
                        />{" "}
                        There is no bank passbook document
                      </Typography>
                    )}
                  </VendorCardLabel>
                </>
              ) : (
                <VendorCardLabel>
                  {bank_passbook_copy_with_bank_stamp_image_name ? (
                    bank_passbook_copy_with_bank_stamp_image_name ? (
                      <CustomDocumentLink
                        href={bank_passbook_copy_with_bank_stamp_image}
                        target="_blank"
                      >
                        <InsertDriveFileOutlined
                          style={{
                            marginTop: "-1px",
                            marginRight: "3px",
                            height: "12px",
                            width: "12px",
                          }}
                        />
                        Bank Passbook document
                      </CustomDocumentLink>
                    ) : (
                      <Typography className="label">
                        <Info
                          sx={{
                            marginTop: "-1px",
                            marginRight: "1px",
                            fill: "grey",
                            height: "15px",
                            width: "15px",
                          }}
                        />{" "}
                        There is no bank passbook document
                      </Typography>
                    )
                  ) : (
                    <Typography className="label">
                      <Info
                        sx={{
                          marginTop: "-1px",
                          marginRight: "1px",
                          fill: "grey",
                          height: "15px",
                          width: "15px",
                        }}
                      />{" "}
                      There is no bank passbook document
                    </Typography>
                  )}
                </VendorCardLabel>
              )}
            </Grid> */}
            {/* new passbook document */}
            <Grid item xs={6} md={4}>
              <Typography className="label">BANK PASSBOOK DOCUMENT</Typography>

              {updated.passbookName.new_value ||
              updated.passbookFile.new_value ? (
                <>
                  <VendorCardLabel>
                    {updated.passbookFile.old_value ? (
                      <RedColorDocumentLink
                        href={updated.passbookFile.old_value}
                        target="_blank"
                      >
                        <InsertDriveFileOutlined
                          sx={{ height: 12, width: 12, mr: 0.5 }}
                        />
                        Bank passbook document{" "}
                      </RedColorDocumentLink>
                    ) : (
                      <NoDocument color="#d32f2f" />
                    )}
                  </VendorCardLabel>

                  <VendorCardLabel>
                    {updated.passbookFile.new_value ? (
                      <GreenColorDocumentLink
                        href={updated.passbookFile.new_value}
                        target="_blank"
                      >
                        <InsertDriveFileOutlined
                          sx={{ height: 12, width: 12, mr: 0.5 }}
                        />
                        Bank passbook document
                      </GreenColorDocumentLink>
                    ) : (
                      <NoDocument color="#2e7d32" />
                    )}
                  </VendorCardLabel>
                </>
              ) : (
                <VendorCardLabel>
                  {bank_passbook_copy_with_bank_stamp_image ? (
                    <CustomDocumentLink
                      href={bank_passbook_copy_with_bank_stamp_image}
                      target="_blank"
                    >
                      <InsertDriveFileOutlined
                        sx={{ height: 12, width: 12, mr: 0.5 }}
                      />
                      Bank statement document
                    </CustomDocumentLink>
                  ) : (
                    <NoDocument />
                  )}
                </VendorCardLabel>
              )}
            </Grid>
            {/* old supporting document */}
            {/* <Grid item xs={6} md={4}>
              <Typography className="label">SUPPORTING DOCUMENT</Typography>
              {findUpdatedBankDetails("supporting_document_image_name") ||
              findUpdatedBankDetails("supporting_document_image") ? (
                <>
                  <VendorCardLabel>
                    {findUpdatedBankDetails("supporting_document_image_name")
                      .old_value ? (
                      findUpdatedBankDetails("supporting_document_image_name")
                        .old_value ? (
                        <RedColorDocumentLink
                          href={
                            findUpdatedBankDetails("supporting_document_image")
                              .old_value
                          }
                          target="_blank"
                        >
                          <InsertDriveFileOutlined
                            style={{
                              marginTop: "-1px",
                              marginRight: "3px",
                              height: "12px",
                              width: "12px",
                            }}
                          />
                          Supporting document
                        </RedColorDocumentLink>
                      ) : (
                        <Typography className="label" sx={{ color: "#d32f2f" }}>
                          <Info
                            sx={{
                              marginTop: "-1px",
                              marginRight: "1px",
                              fill: "grey",
                              height: "15px",
                              width: "15px",
                            }}
                          />{" "}
                          There is no supporting document
                        </Typography>
                      )
                    ) : (
                      <Typography className="label" sx={{ color: "#d32f2f" }}>
                        <Info
                          sx={{
                            marginTop: "-1px",
                            marginRight: "1px",
                            fill: "grey",
                            height: "15px",
                            width: "15px",
                          }}
                        />{" "}
                        There is no supporting document
                      </Typography>
                    )}
                  </VendorCardLabel>
                  <VendorCardLabel>
                    {findUpdatedBankDetails("supporting_document_image_name")
                      .new_value ? (
                      findUpdatedBankDetails("supporting_document_image_name")
                        .new_value ? (
                        <GreenColorDocumentLink
                          href={
                            findUpdatedBankDetails("supporting_document_image")
                              .new_value
                          }
                          target="_blank"
                        >
                          <InsertDriveFileOutlined
                            style={{
                              marginTop: "-1px",
                              marginRight: "3px",
                              height: "12px",
                              width: "12px",
                            }}
                          />
                          Supporting document
                        </GreenColorDocumentLink>
                      ) : (
                        <Typography className="label" sx={{ color: "#2e7d32" }}>
                          <Info
                            sx={{
                              marginTop: "-1px",
                              marginRight: "1px",
                              fill: "grey",
                              height: "15px",
                              width: "15px",
                            }}
                          />{" "}
                          There is no supporting document
                        </Typography>
                      )
                    ) : (
                      <Typography className="label" sx={{ color: "#2e7d32" }}>
                        <Info
                          sx={{
                            marginTop: "-1px",
                            marginRight: "1px",
                            fill: "grey",
                            height: "15px",
                            width: "15px",
                          }}
                        />{" "}
                        There is no supporting document
                      </Typography>
                    )}
                  </VendorCardLabel>
                </>
              ) : (
                <VendorCardLabel>
                  {supporting_document_image_name ? (
                    supporting_document_image_name ? (
                      <CustomDocumentLink
                        href={supporting_document_image}
                        target="_blank"
                      >
                        <InsertDriveFileOutlined
                          style={{
                            marginTop: "-1px",
                            marginRight: "3px",
                            height: "12px",
                            width: "12px",
                          }}
                        />
                        Supporting document
                      </CustomDocumentLink>
                    ) : (
                      <Typography className="label">
                        <Info
                          sx={{
                            marginTop: "-1px",
                            marginRight: "1px",
                            fill: "grey",
                            height: "15px",
                            width: "15px",
                          }}
                        />{" "}
                        There is no supporting document
                      </Typography>
                    )
                  ) : (
                    <Typography className="label">
                      <Info
                        sx={{
                          marginTop: "-1px",
                          marginRight: "1px",
                          fill: "grey",
                          height: "15px",
                          width: "15px",
                        }}
                      />{" "}
                      There is no supporting document
                    </Typography>
                  )}
                </VendorCardLabel>
              )}
            </Grid> */}
            <Grid item xs={6} md={4}>
              <Typography className="label">SUPPORTING DOCUMENT</Typography>

              {updated.statementName.new_value ||
              updated.supportName.new_value ? (
                <>
                  <VendorCardLabel>
                    {updated.supportFile.old_value ? (
                      <RedColorDocumentLink
                        href={updated.supportFile.old_value}
                        target="_blank"
                      >
                        <InsertDriveFileOutlined
                          sx={{ height: 12, width: 12, mr: 0.5 }}
                        />
                        Supporting document
                      </RedColorDocumentLink>
                    ) : (
                      <NoDocument color="#d32f2f" />
                    )}
                  </VendorCardLabel>

                  <VendorCardLabel>
                    {updated.supportFile.new_value ? (
                      <GreenColorDocumentLink
                        href={updated.supportFile.new_value}
                        target="_blank"
                      >
                        <InsertDriveFileOutlined
                          sx={{ height: 12, width: 12, mr: 0.5 }}
                        />
                        Supporting document
                      </GreenColorDocumentLink>
                    ) : (
                      <NoDocument color="#2e7d32" />
                    )}
                  </VendorCardLabel>
                </>
              ) : (
                <VendorCardLabel>
                  {supporting_document_image ? (
                    <CustomDocumentLink
                      href={supporting_document_image}
                      target="_blank"
                    >
                      <InsertDriveFileOutlined
                        sx={{ height: 12, width: 12, mr: 0.5 }}
                      />
                      Bank statement document
                    </CustomDocumentLink>
                  ) : (
                    <NoDocument />
                  )}
                </VendorCardLabel>
              )}
            </Grid>

            <Grid item xs={6} md={4}></Grid>
          </Grid>
          <br />
        </CardContent>
      </Card>
      {/* dialog  box*/}
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: "move", fontWeight: "Bold" }}>
          Reason for Deleting Bank Information
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Reason for deletion.<Super>*</Super>
          </DialogContentText>
          <DialogContentText>
            <form onSubmit={handleSubmit(onSubmit)}>
              <FormControl
                variant="standard"
                style={{ width: "100%" }}
                error={Boolean(errors?.reason)}
              >
                <TextField
                  style={{ width: "100%" }}
                  sx={{
                    input: {
                      fontSize: "14px",
                      fontFamily: "var(--font-family-reg)",
                    },
                  }}
                  placeholder="Enter Reason"
                  variant="standard"
                  name="reason"
                  {...register("reason", {
                    required: "please enter reason",
                  })}
                  error={Boolean(errors?.reason)}
                  helperText={errors.reason?.message}
                />
              </FormControl>
              <Grid
                sx={{
                  display: "flex",
                  gap: "1rem",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "1rem",
                }}
              >
                <Button
                  autoFocus
                  onClick={handleClose}
                  style={{ height: "40px", border: "#4059e5 solid 1px" }}
                >
                  Cancel
                </Button>
                <LoadingButton
                  sx={{
                    textTransform: "none",
                    background: "#4059e5",
                    width: "200px",
                    height: "40px",
                  }}
                  color="primary"
                  variant="contained"
                  type="submit"
                  loading={loading}
                  loadingPosition="start"
                >
                  DELETE
                </LoadingButton>
              </Grid>
            </form>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ alignItems: "right" }}></DialogActions>
      </Dialog>
    </>
  );
};

export default BankInfoDetails;

export const BankName = styled.div`
  font-family: var(--font-family-reg);
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 30px;
  /* identical to box height, or 167% */

  /* Neutral/900 */

  color: #212134;
`;
